import { Injectable } from '@angular/core'
import {
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
  Resolve,
} from '@angular/router'
import { Observable } from 'rxjs'
import { TransferService } from '../../services'
import { Logger } from '../../logger.service'
import { map, catchError } from 'rxjs/operators'
import { Transfer } from '../../models'

const log = new Logger('TransferDetailResolver')
@Injectable({ providedIn: 'root' })
export class TransferDetailResolver implements Resolve<Observable<Transfer>> {
  constructor(
    private transferService: TransferService,
    private router: Router
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any> {
    let mode = route.params['mode']
    let tid = route.params['tid']
    
    return this.transferService.getDetail(tid).pipe(
      map(data => {
        log.debug('Data: ', data)
        return data
      }),
      catchError(err => this.router.navigate(['/activity/transfer']))
    )
  }
}
